"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigratedConsumables = exports.Pelican2Only = exports.Catalogue = exports.Installed = exports.Catalog = exports.InstalledList = exports.InstalledItem = exports.CatalogItem = exports.PatchRejected = exports.PatchBody = exports.PatchInstruction = exports.ParseIssue = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../device"));
const mix_ratio_1 = require("../../../../../../device/capability/consumable/definition/enhancement/mix-ratio");
const openapi_1 = require("../../../../../openapi");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Consumable.Schema';
const LegacyTimestamp = effect_1.Schema.Literal('2025-02-28T12:00:00.000Z');
const LegacyKind = effect_1.Schema.Literal('enhancements', 'filter', 'CO2', 'uvcLight');
/**
 * Effect `ArrayFormatter` issue as the consumable patch and migrate handlers return it.
 * The formatter adds further keys per issue kind; these three are on every issue.
 */
exports.ParseIssue = effect_1.Schema.Struct({
    _tag: effect_1.Schema.String,
    path: effect_1.Schema.Array(effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Number)),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.ParseIssue`,
});
/** One slot update. `subsetId` of null clears the slot. Dates are epoch milliseconds. */
exports.PatchInstruction = effect_1.Schema.Struct({
    subsetId: effect_1.Schema.NullOr(Device.Capability.Consumable.Definition.Id),
    expiresAt: effect_1.Schema.DateFromNumber,
    index: effect_1.Schema.Int,
    installedAt: effect_1.Schema.DateFromNumber,
    current: effect_1.Schema.Number,
    batch: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.PatchInstruction`,
});
/** The body is one instruction or an array of them. An empty array is accepted. */
exports.PatchBody = effect_1.Schema.Union(exports.PatchInstruction, effect_1.Schema.Array(exports.PatchInstruction)).annotations({
    identifier: `${exports.NAMESPACE}.PatchBody`,
});
/** 400: the patch body did not decode. `message` is `BAD_REQUEST`. */
exports.PatchRejected = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('BAD_REQUEST'),
        validationErrors: effect_1.Schema.Array(exports.ParseIssue),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.PatchRejected`,
    title: 'Consumable patch rejected',
    description: 'The consumable patch body did not decode.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 400,
});
const LegacyConsumable = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    kind: LegacyKind,
    name: effect_1.Schema.String,
    type: effect_1.Schema.Literal('default'),
    createdAt: LegacyTimestamp,
    updatedAt: LegacyTimestamp,
    description: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.LegacyConsumable`,
});
const FlavorDefinition = effect_1.Schema.Struct({
    consumable: effect_1.Schema.String,
    id: effect_1.Schema.String,
    name: effect_1.Schema.String,
    carbohydratesValue: effect_1.Schema.Number,
    coverImage: effect_1.Schema.NullOr(effect_1.Schema.String),
    createdAt: LegacyTimestamp,
    darkColor: effect_1.Schema.String,
    darkerColor: effect_1.Schema.NullOr(effect_1.Schema.String),
    description: effect_1.Schema.String,
    drinkDescription: effect_1.Schema.NullOr(effect_1.Schema.String),
    drinkFlavor: effect_1.Schema.String,
    drinkName: effect_1.Schema.String,
    energyValueKcal: effect_1.Schema.Number,
    energyValueKj: effect_1.Schema.Number,
    expirationMethod: effect_1.Schema.Literal('expirationDate'),
    fatValue: effect_1.Schema.Number,
    fibreValue: effect_1.Schema.Number,
    flavored: effect_1.Schema.Boolean,
    foregroundColor: effect_1.Schema.NullOr(effect_1.Schema.String),
    ingredients: effect_1.Schema.Array(effect_1.Schema.String),
    lifespan: effect_1.Schema.Null,
    lightColor: effect_1.Schema.String,
    lighterColor: effect_1.Schema.NullOr(effect_1.Schema.String),
    lightestColor: effect_1.Schema.NullOr(effect_1.Schema.String),
    mixRatioScalars: mix_ratio_1.MixRatioScalars,
    nominalMixRatio: mix_ratio_1.NominalMixRatio,
    normalColor: effect_1.Schema.NullOr(effect_1.Schema.String),
    partitionKey: effect_1.Schema.Literal('default'),
    perWhichSaturated: effect_1.Schema.Number,
    perWhichSugars: effect_1.Schema.Number,
    proteinValue: effect_1.Schema.Number,
    rangeExhaust: effect_1.Schema.Number,
    rangeFullCapacity: effect_1.Schema.Number,
    rangeTrigger: effect_1.Schema.Number,
    sodiumValue: effect_1.Schema.Number,
    tags: effect_1.Schema.Array(effect_1.Schema.String),
    textColor: effect_1.Schema.String,
    themeName: effect_1.Schema.Null,
    unitOfMeasure: effect_1.Schema.String,
    updatedAt: LegacyTimestamp,
}).annotations({
    identifier: `${exports.NAMESPACE}.FlavorDefinition`,
});
const ExpendableDefinition = effect_1.Schema.Struct({
    consumable: effect_1.Schema.String,
    id: effect_1.Schema.String,
    name: effect_1.Schema.String,
    createdAt: LegacyTimestamp,
    description: effect_1.Schema.String,
    expirationMethod: effect_1.Schema.Literal('replaceAfter'),
    lifespan: effect_1.Schema.Literal(365),
    partitionKey: effect_1.Schema.Literal('default'),
    rangeExhaust: effect_1.Schema.Number,
    rangeFullCapacity: effect_1.Schema.Number,
    rangeTrigger: effect_1.Schema.Number,
    unitOfMeasure: effect_1.Schema.String,
    updatedAt: LegacyTimestamp,
}).annotations({
    identifier: `${exports.NAMESPACE}.ExpendableDefinition`,
});
const FlavorItem = effect_1.Schema.Struct({
    consumable: LegacyConsumable,
    type: effect_1.Schema.Literal('enhancements'),
    subset: effect_1.Schema.Struct({ definition: FlavorDefinition }),
}).annotations({
    identifier: `${exports.NAMESPACE}.FlavorItem`,
});
const ExpendableItem = effect_1.Schema.Struct({
    consumable: LegacyConsumable,
    type: effect_1.Schema.Literal('filter', 'CO2', 'uvcLight'),
    subset: effect_1.Schema.Struct({ definition: ExpendableDefinition }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ExpendableItem`,
});
/** One catalog row, in the legacy shape `mapPelicanConsumableToLegacyFormat` returns. */
exports.CatalogItem = effect_1.Schema.Union(FlavorItem, ExpendableItem).annotations({
    identifier: `${exports.NAMESPACE}.CatalogItem`,
});
const FlavorState = effect_1.Schema.Struct({
    batch: effect_1.Schema.NullOr(effect_1.Schema.String),
    expiration: effect_1.Schema.Number,
    installedAt: effect_1.Schema.Number,
    current: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.FlavorState`,
});
const ExpendableState = effect_1.Schema.Struct({
    batch: effect_1.Schema.Null,
    current: effect_1.Schema.Number,
    expiration: effect_1.Schema.Number,
    installedAt: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.ExpendableState`,
});
const InstalledFlavor = effect_1.Schema.Struct({
    consumable: LegacyConsumable,
    type: effect_1.Schema.Literal('enhancements'),
    subset: effect_1.Schema.Struct({ definition: FlavorDefinition, state: FlavorState }),
}).annotations({
    identifier: `${exports.NAMESPACE}.InstalledFlavor`,
});
const InstalledExpendable = effect_1.Schema.Struct({
    consumable: LegacyConsumable,
    type: effect_1.Schema.Literal('filter', 'CO2', 'uvcLight'),
    subset: effect_1.Schema.Struct({ definition: ExpendableDefinition, state: ExpendableState }),
}).annotations({
    identifier: `${exports.NAMESPACE}.InstalledExpendable`,
});
const EmptySlot = effect_1.Schema.Struct({
    consumable: LegacyConsumable,
    type: LegacyKind,
    subset: effect_1.Schema.Null,
}).annotations({
    identifier: `${exports.NAMESPACE}.EmptySlot`,
});
/** One installed slot, including an empty slot (`subset: null`). */
exports.InstalledItem = effect_1.Schema.Union(InstalledFlavor, InstalledExpendable, EmptySlot).annotations({
    identifier: `${exports.NAMESPACE}.InstalledItem`,
});
/** Legacy slot list returned by the consumable patch. `data` is the array itself. */
exports.InstalledList = effect_1.Schema.Array(exports.InstalledItem).annotations({
    identifier: `${exports.NAMESPACE}.InstalledList`,
});
exports.Catalog = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.CatalogItem),
}).annotations({
    identifier: `${exports.NAMESPACE}.Catalog`,
    description: 'Legacy consumable catalog. The handler ignores the query and keeps six consumable tags: ' +
        'LiquidEnhancement, PreCarbonBlockFilter, CarbonBlockFilter, LimescaleFilter, UVCLight, CO2Tank.',
});
exports.Installed = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.InstalledItem),
}).annotations({
    identifier: `${exports.NAMESPACE}.Installed`,
    description: 'Legacy view of the Pelican2 slots. An empty slot has subset: null.',
});
/** Per-model catalogue returned by GET catalogue, already encoded. */
exports.Catalogue = effect_1.Schema.Union(Device.Class.Pelican2.Catalogue, Device.Class.Blackbox.Catalogue, Device.Class.Gbfc.Catalogue, Device.Class.HydroTapBridge.Catalogue).annotations({
    identifier: `${exports.NAMESPACE}.Catalogue`,
    description: 'Consumable catalogue for the device model in the session.',
});
/** 422: installed consumables were requested for a device that is not a Pelican2. */
exports.Pelican2Only = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.Pelican2Only`, 'INVALID_REQUEST', 'Pelican2 only', 'Installed consumables are returned only for a Pelican2. detail names the model that was sent.', { detail: effect_1.Schema.String });
/** Encoded Pelican2 slots returned by the migrate handler. */
exports.MigratedConsumables = Device.Class.Pelican2.Pelican2.fields.consumables.annotations({
    identifier: `${exports.NAMESPACE}.MigratedConsumables`,
    description: 'Pelican2 consumable slots after the migrate handler encodes the updated device.',
});
//# sourceMappingURL=schema.js.map